// extracted by mini-css-extract-plugin
module.exports = {"root":"DailyList_root__1dzKF","item":"DailyList_item__2kt5o","disabled":"DailyList_disabled__3I_Y3","icon":"DailyList_icon__3Whc9","text":"DailyList_text__2Nf_p"};